// extracted by mini-css-extract-plugin
module.exports = {"destinations":"destinations_destinations__21w66","content":"destinations_content__1kz6a","destinationList":"destinations_destinationList__3-Ae-"};